
import { Component, Input, OnInit } from "@angular/core";
import { CommonService } from "../../services/common.service";

@Component({
  selector: 'app-player-orders-card',
  templateUrl: './player-orders-card.html',
  styleUrls: ['./player-orders-card.scss']
})
export class PlayerOrdersCardComponent implements OnInit {

    @Input() playerOrdersList:any = [];
    currentUser:any;

  constructor(
    private commonService: CommonService
  ) { }
  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);
  }
  formatEventDate(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "Aug 17, 2025"
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }

  formatEventTime(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "3:30 PM"
    return d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }
  convertToDecimal(data:any){
    return data.toFixed(2);
  }

  viewDetails(id:any){
    this.commonService.sendOrderIdPlayer(id)
  }
}
